// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__sexYu","nav":"styles_nav__PwBnS","content":"styles_content__QLlJk","filter-input":"styles_filter-input__up6iS","noScroll":"styles_noScroll__xxCPy"};